import React, { useEffect, useRef, useState } from 'react';
import { ReportAPI } from '../../../Api/ReportAPI';
import { ServiceInfo } from '../../../Utilis';
import VideoItem from './VideoItem';
import { API_URL } from '../../../Api/ServiceAPI';
import { ReactComponent as DownloadIcon } from "../../../Png/download-solid.svg"

const ReportItem = ({ report, setShowedReport, showReportId }) => {
  const [videoUrl, setVideoUrl] = useState('');
  const [showVideo, setShowVideo] = useState(false);
  const [reportFilePdf,setReportFilePdf]=useState(null)
  const [videoReportProgress,setVideoReportProgress]=useState(0)
  const isDownloading=useRef(false)
  const handleDownload = () => {
    if (!videoUrl) {
      alert('No video URL available for downloading');
      return;
    }

    const link = document.createElement('a');
    link.href = videoUrl;
    link.setAttribute('download', report.videoName || 'download');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleViewDetails = () => {
    setShowedReport(); // Set the current report as opened
  
    // Check if the serviceNumber is between 0 and 9
    if (report["serviceNumber"] >= 0 && report["serviceNumber"] <= 9) {
      // setVideoUrl(report.Id);
      //       setShowVideo(true);
      if(report?.videoReportId)
        ReportAPI.getHlsVideo(report.Id)
              .then((res) => {
                  if (res.data.result === 0) {
                      // Use the proxy server for the video URL
                      const proxyUrl = `${API_URL}/proxyVideo?url=https://${res.data.variants[0].hosts[0]}${res.data.variants[0].path}`;
                      setVideoUrl(proxyUrl);
                      setShowVideo(true);
                  }
              })
              .catch((error) => {
                  console.error('Failed to load video:', error);
              });
      }
  };
  useEffect(()=>{
    if(showReportId==report.Id){
      setVideoUrl("")
      setShowVideo(false)
      setReportFilePdf(null)
    }
  },[showReportId])

  const handleDownloadVideoReport = () => {
    
    if(isDownloading.current) return
    isDownloading.current=true;
    // Construct the URL for the video file
    ReportAPI.getVideoDownloadLink(report.Id,setVideoReportProgress).then(response => {
        const blob= response.data
        // Create a URL for the blob object
        const url = window.URL.createObjectURL(blob);
        // Create a temporary anchor element
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // Suggest a filename for the download
        a.download = report.videoReport; // You might want to dynamically determine the file name based on the response or another method
        // Append the anchor to the body, click it, and then remove it
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }).finally(()=>{
      isDownloading.current=false;
      setVideoReportProgress(0)
    })
    .catch(err => console.error('Error downloading file:', err));
   
  };
  function fetchReport(fileType) {
    let url=""
    let filename=""
    let report_data_id=null
    switch(fileType){
      case 0:
        if(report.pdfReport.split(".").pop()!="pdf")
          fileType=1
          report_data_id=report.pdfReportId
        filename=report.pdfReport
        break;
      case 1:
        filename=report.pdfReport
        report_data_id=report.pdfReportId
        break;
      case 2:
        filename=report.excelReport
        report_data_id=report.excelReportId
        break;
        default:
          return

    }
    
   ReportAPI.getReportFile(report_data_id,fileType).then((response) => {
      switch(fileType){
        case 0:
          handlePdf(response.data,filename)
          break
        case 1:
          handleFileDownload(response.data,filename)
          break;
        case 2:
          handleFileDownload(response.data,filename)
          break;

      }
    
    })
    .catch((error) => {
      console.error("Error fetching PDF:", error);
    });
  }
  function handleFileDownload(blob,filename){
    const fileUrl = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.setAttribute('download', filename); // Optional: Specify a default filename
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl); // Clean up

  }
  function handlePdf(blob){
    const file = new Blob([blob], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    setReportFilePdf(fileURL);
  }

  const parseDateTime=(datetime)=>{
    console.log(datetime)
    let date=new Date(datetime)
    return `${date.getUTCHours()}:${date.getUTCMinutes()}h ${date.getUTCDate()}.${date.getUTCMonth()+1}.${date.getUTCFullYear()}`
  }
  return (
    <div className="report-item">
      <h3>{report.folderName}</h3>
      <p className='service'>Service: {Object.entries(ServiceInfo).filter((service)=>service[1].serviceNumber==report.serviceNumber)[0][1].displayName}</p>
      {report?.folder_uploaded&&<p className='service'>Uploaded time:<span className='date-info'>{parseDateTime(report.folder_uploaded)}</span>    {report?.report_finished&&<span>Report finished:<span className='date-info'>{parseDateTime(report.report_finished)}</span></span>}</p>}
      
      {showVideo&&showReportId==report["Id"]?<>
      <div className="pdfFileAndDownload">
        <h4>Video report:</h4>
      <a onClick={handleDownloadVideoReport}><DownloadIcon className="icon" />{report.videoReport}</a>
      {videoReportProgress > 0&&isDownloading.current ?<>
        <div>
          <p>Download progress:</p> 
      <progress value={videoReportProgress} max="100"></progress>
                    <span>{videoReportProgress.toFixed(1)}%</span></div></>:null}
      </div>
      {report?.videoReportId?<VideoItem videoUrl={videoUrl} showVideo={showVideo} />:null}
      </>
      :null}

      {report.pdfReport&&showReportId==report["Id"]?

      <div onClick={()=>{fetchReport(0)}} className='pdfReport'>
        <h4>Report:</h4>
        <p className='reportName'>{report.pdfReport}</p>
        {reportFilePdf?
          <div className="pdfFileAndDownload">
          <a href={reportFilePdf} download={report.pdfReport}><DownloadIcon className="icon" />{report.pdfReport}</a>
            <iframe title={report.pdfReport} src={reportFilePdf} width="100%" height="500px" />
          </div>:null}
      </div>
      :null}
      {report?.excelReportId&&report?.excelReport&&showReportId==report["Id"]?
      <div onClick={()=>{fetchReport(2)}} className='pdfReport'>
      <h4>Report csv:</h4>
      <p className='reportName'>{report?.excelReport}</p>
    </div>
      :null
    }
      
      <div className="button-container">
        {report?.videoReportId||report?.pdfReportId||report?.excelReportId?
          <button onClick={handleViewDetails}>View Details</button>
        :null}
       {/* <button onClick={handleDownload}>Download</button>  */}
      </div> 
    </div>
  );
};

export default ReportItem;
